import './Sobre.css'
import { motion } from "framer-motion"
import oficinaImg from "../../img/oficina.jpg"

const Sobre = () => {
    return (
        <section className="sobre-container">
            <motion.div 
                className="sobre-content"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
            >
                <h2 className="section-title">SOBRE <span className="highlight">NÓS</span></h2>
                <div className="divider"></div>
                <p>
                    Sob o comando de <strong>Vander W. Fioretti</strong>, amplamente conhecido como o 
                    <span className="quote"> "Mestre das Mercedes"</span>, nossa oficina é referência 
                    desde 1990 no segmento de luxo.
                </p>
                <p>
                    Com sede em Balneário Camboriú-SC, a <strong>Stuttgart Motors</strong> é mais que uma oficina: 
                    é um centro de excelência. Além de assistência técnica VIP, somos um polo de 
                    treinamento e consultoria para profissionais que buscam a perfeição no 
                    diagnóstico e manutenção da linha Mercedes-Benz.
                </p>
            </motion.div>
            
            <motion.div 
                className="sobre-image"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
            >
                <img src={oficinaImg} alt="Oficina Stuttgart" />
                <div className="image-overlay"></div>
            </motion.div>
        </section>
    );
}

export default Sobre;